import createContext from '../../support/helpers/createContext';

import { EvaluationFormDefinition } from '../../types/shared/EvaluationForm';
import { Produce } from './useImmer';

type BuilderContext = {
  activeFieldId: string | null | undefined;
  activeFieldIndex: number | null | undefined;
  setActiveField: (arg0: {
    activeFieldId: string | null | undefined;
    activeFieldIndex: number | null | undefined;
  }) => void;
  update: Produce<EvaluationFormDefinition>;
};

let [useBuilderState, BuilderStateProvider] = createContext<BuilderContext>();

export { useBuilderState, BuilderStateProvider };
